import { Typography } from "antd";

import * as theme from "./CustomEllipsisLabel.css";

const { Text } = Typography;

/**
 * Custom label component that applies ellipsis with a tooltip for long text values.
 * Used in table filters in combination with MultipleSelectFilter, especially to create an ellipsis for long control program names
 *
 * @param text - The text to display in the label. If the text exceeds the container width, it will be truncated with an ellipsis, and the full text will be shown in a tooltip on hover.
 */

export function CustomEllipsisLabel({ text }: { text: string }) {
    return (
        <Text ellipsis={{ tooltip: text }} className={theme.filterLabel}>
            {text}
        </Text>
    );
}
